import React from "react";

// Material UI imports
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

// components
import AddNewPropertyModalContent from "./AddNewPropertyModalContent";

// Styling
import "./AddNewClassModals.css";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "50px",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const AddNewPropertyModal = ({
  isAddPropertyModalOpen,
  setIsAddPropertyModalOpen,
}) => {
  const classes = useStyles();

  const handleClose = () => {
    setIsAddPropertyModalOpen(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={isAddPropertyModalOpen}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isAddPropertyModalOpen}>
          <AddNewPropertyModalContent
            setIsAddPropertyModalOpen={setIsAddPropertyModalOpen}
          />
        </Fade>
      </Modal>
    </div>
  );
};

export default AddNewPropertyModal;
